import {
  DeploymentModel,
  DeploymentStatus,
  DeploymentType,
} from '@sunstone/api-client/gen/deployments/v1/deployments_pb';

export function deploymentTypeKey(t: DeploymentType): string {
  switch (t) {
    case DeploymentType.CLOUD_AWS:
      return 'DEPLOYMENT_TYPE_CLOUD_AWS';
    case DeploymentType.CLOUD_GCP:
      return 'DEPLOYMENT_TYPE_CLOUD_GCP';
    case DeploymentType.CLOUD_AZURE:
      return 'DEPLOYMENT_TYPE_CLOUD_AZURE';
    case DeploymentType.ON_PREM:
      return 'DEPLOYMENT_TYPE_ON_PREM';
    default:
      return 'DEPLOYMENT_TYPE_UNSPECIFIED';
  }
}

export function deploymentTypeFromKey(key: string | null): DeploymentType {
  switch (key) {
    case 'DEPLOYMENT_TYPE_CLOUD_AWS':
      return DeploymentType.CLOUD_AWS;
    case 'DEPLOYMENT_TYPE_CLOUD_GCP':
      return DeploymentType.CLOUD_GCP;
    case 'DEPLOYMENT_TYPE_CLOUD_AZURE':
      return DeploymentType.CLOUD_AZURE;
    case 'DEPLOYMENT_TYPE_ON_PREM':
      return DeploymentType.ON_PREM;
    default:
      return DeploymentType.UNSPECIFIED;
  }
}

export function deploymentModelKey(m: DeploymentModel): string {
  switch (m) {
    case DeploymentModel.HYBRID:
      return 'DEPLOYMENT_MODEL_HYBRID';
    case DeploymentModel.FULL_CUSTOMER_VPC:
      return 'DEPLOYMENT_MODEL_FULL_CUSTOMER_VPC';
    case DeploymentModel.ON_PREM:
      return 'DEPLOYMENT_MODEL_ON_PREM';
    case DeploymentModel.SAAS:
      return 'DEPLOYMENT_MODEL_SAAS';
    case DeploymentModel.AIRGAPPED:
      return 'DEPLOYMENT_MODEL_AIRGAPPED';
    default:
      return 'DEPLOYMENT_MODEL_UNSPECIFIED';
  }
}

export function deploymentStatusKey(s: DeploymentStatus): string {
  switch (s) {
    case DeploymentStatus.CREATED:
      return 'DEPLOYMENT_STATUS_CREATED';
    case DeploymentStatus.AWAITING_BOOTSTRAP:
      return 'DEPLOYMENT_STATUS_AWAITING_BOOTSTRAP';
    case DeploymentStatus.BOOTSTRAP_FAILED:
      return 'DEPLOYMENT_STATUS_BOOTSTRAP_FAILED';
    case DeploymentStatus.PROVISIONING:
      return 'DEPLOYMENT_STATUS_PROVISIONING';
    case DeploymentStatus.PHASE_1_COMPLETE:
      return 'DEPLOYMENT_STATUS_PHASE_1_COMPLETE';
    case DeploymentStatus.PROVISIONED:
      return 'DEPLOYMENT_STATUS_PROVISIONED';
    case DeploymentStatus.ACTIVE:
      return 'DEPLOYMENT_STATUS_ACTIVE';
    case DeploymentStatus.MAINTENANCE:
      return 'DEPLOYMENT_STATUS_MAINTENANCE';
    case DeploymentStatus.INACTIVE:
      return 'DEPLOYMENT_STATUS_INACTIVE';
    case DeploymentStatus.DEPROVISIONING:
      return 'DEPLOYMENT_STATUS_DEPROVISIONING';
    case DeploymentStatus.MANAGEMENT_BLOCKED:
      return 'DEPLOYMENT_STATUS_MANAGEMENT_BLOCKED';
    case DeploymentStatus.BOOTSTRAP_TIMEOUT:
      return 'DEPLOYMENT_STATUS_BOOTSTRAP_TIMEOUT';
    case DeploymentStatus.PHASE_2_COMPLETE:
      return 'DEPLOYMENT_STATUS_PHASE_2_COMPLETE';
    default:
      return 'DEPLOYMENT_STATUS_UNSPECIFIED';
  }
}

export function deploymentStatusFromKey(key: string | null): DeploymentStatus {
  switch (key) {
    case 'DEPLOYMENT_STATUS_CREATED':
      return DeploymentStatus.CREATED;
    case 'DEPLOYMENT_STATUS_AWAITING_BOOTSTRAP':
      return DeploymentStatus.AWAITING_BOOTSTRAP;
    case 'DEPLOYMENT_STATUS_BOOTSTRAP_FAILED':
      return DeploymentStatus.BOOTSTRAP_FAILED;
    case 'DEPLOYMENT_STATUS_PROVISIONING':
      return DeploymentStatus.PROVISIONING;
    case 'DEPLOYMENT_STATUS_PHASE_1_COMPLETE':
      return DeploymentStatus.PHASE_1_COMPLETE;
    case 'DEPLOYMENT_STATUS_PROVISIONED':
      return DeploymentStatus.PROVISIONED;
    case 'DEPLOYMENT_STATUS_ACTIVE':
      return DeploymentStatus.ACTIVE;
    case 'DEPLOYMENT_STATUS_MAINTENANCE':
      return DeploymentStatus.MAINTENANCE;
    case 'DEPLOYMENT_STATUS_INACTIVE':
      return DeploymentStatus.INACTIVE;
    case 'DEPLOYMENT_STATUS_DEPROVISIONING':
      return DeploymentStatus.DEPROVISIONING;
    case 'DEPLOYMENT_STATUS_MANAGEMENT_BLOCKED':
      return DeploymentStatus.MANAGEMENT_BLOCKED;
    case 'DEPLOYMENT_STATUS_BOOTSTRAP_TIMEOUT':
      return DeploymentStatus.BOOTSTRAP_TIMEOUT;
    case 'DEPLOYMENT_STATUS_PHASE_2_COMPLETE':
      return DeploymentStatus.PHASE_2_COMPLETE;
    default:
      return DeploymentStatus.UNSPECIFIED;
  }
}
